import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import { LoadingSpinner, Button, pitchType, PitchLocation, styles } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import { useOktaQuery, Video } from '../data';
import { StyledReportCard, reportCardBorder } from './ReportCard';

const StyledTabs = styled.div`
    > div + div {
        margin: 0;
        border: ${reportCardBorder};
        border-radius: 0.25rem;
    }
`;
const Container = styled.div`
    width: 95%;
    box-shadow: rgb(0 0 0 / 50%) 0 1px 2px 0px;
    background-color: white;
    > * {
        margin-bottom: 20px;
    }
    ${StyledReportCard} .card-body > h4, ${StyledTabs} > div + div > h4 {
        font-size: 18px;
        font-weight: bold;
        text-align: left;
        text-transform: uppercase;
    }
    .table {
        font-size: 12px;
    }
    .playing {
        border-color: #0077D9 !important;
        border-width: 2px !important;
    }
    .editMode {
        border-color: #0077D9 !important;
        border-width: 2px !important;
        border-style: dashed;
    }
    .notPlaying {
        border-color: transparent !important;
        border-width: 3px !important;
    }
`;
const FullWidthButton = styled(Button)`
    width: 100%;
    > button {
        height: 100%;
        color: red;
    }
`;

const ApproachVideoButton = ({ pitcherId, batterId, approachPitch, isPlaying, isEditMode, onVideosDownloaded, onPlayThisPlaylist, onEditThisPlaylist }) => {
    const { t: translate } = useTranslation();
    const isDownloaded = approachPitch && approachPitch.videos && approachPitch.videos.length > 0;
    const { isFetching: savedSearchLoading } = useOktaQuery(['userSavedSearch', { approachPitch }],
        (t) => Video.search(t, { approachTab: true, batterId, pitcherId, fxpitchtype: approachPitch.FXType, LocationX: approachPitch.LocationX, LocationY: approachPitch.LocationY, IsPitchStart: approachPitch.IsPitchStart }),
        { enabled: !isDownloaded,
            onSuccess: (data) => { onVideosDownloaded(approachPitch.ApproachPitchID, data?.videos); } });
    const buttonReady = isDownloaded && !savedSearchLoading;
    const noop = () => {};

    return (
        <Container>
            <FullWidthButton
                // eslint-disable-next-line no-nested-ternary
                className={isEditMode ? 'editMode' : isPlaying ? 'playing' : 'notPlaying'}
                variant="default"
                // eslint-disable-next-line no-nested-ternary
                onClick={() => (isEditMode ? onEditThisPlaylist(approachPitch.ApproachPitchID) : isDownloaded ? onPlayThisPlaylist(approachPitch.ApproachPitchID) : noop())}
                style={{ backgroundColor: 'unset', borderRadius: '4px' }}
            >
                {!buttonReady && <LoadingSpinner size="sm" style={{ marginTop: '5px' }} />}
                {buttonReady && (
                    <Row className="g-0">
                        <Col style={{ marginTop: 'auto', marginBottom: 'auto' }} className="p-0">
                            <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{pitchType(approachPitch.FXType, true, undefined, translate)}</span>
                        </Col>
                        <Col>
                            <PitchLocation
                                size={30}
                                locations={[{ locationx: approachPitch.LocationX, locationy: approachPitch.LocationY }]}
                                emptyColor="#98CBFF"
                                strikeZoneColor="#D2D2D2"
                                fillColor={approachPitch.IsPitchStart ? '#0077D9' : styles.theme.background.red}
                            /><br /><span style={{ color: styles.theme.background.boulder, fontSize: '12px' }}>{approachPitch.IsPitchStart ? translate('common.start') : translate('common.end')}</span>
                        </Col>
                    </Row>
                )}
            </FullWidthButton>
        </Container>
    );
};

ApproachVideoButton.propTypes = {
    approachPitch: PropTypes.shape({
        ApproachPitchID: PropTypes.number.isRequired,
        IsPitchStart: PropTypes.bool.isRequired,
        LocationX: PropTypes.number.isRequired,
        LocationY: PropTypes.number.isRequired,
        FXType: PropTypes.number.isRequired,
        videos: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    isPlaying: PropTypes.bool,
    isEditMode: PropTypes.bool.isRequired,
    onVideosDownloaded: PropTypes.func.isRequired,
    onPlayThisPlaylist: PropTypes.func.isRequired,
    onEditThisPlaylist: PropTypes.func.isRequired,
    pitcherId: PropTypes.number.isRequired,
    batterId: PropTypes.number.isRequired,
};

ApproachVideoButton.defaultProps = {
    isPlaying: false,
};

export default ApproachVideoButton;
